export enum MessageMethod {
    CONNECTION = 'connection',
    DRAW = 'draw'
}

export enum FigureTypes {
    BRUSH = 'brush',
    FINISH = 'finish',
    RECT = 'rect',
    CLEAR = 'clear'
}

interface IFigure {
    type: string,
    x: number,
    y: number,
    width: number,
    height: number,
    color: string
}

export interface MessageType {
    method: string,
    id: string,
    username: string,
    message: string,
    figure: IFigure
}